/* ============================================================================
   Skèmino — product.js
   Product page: variant selection, media swap, quantity stepper,
   sticky add-to-cart bar visibility. Vanilla, no build step. Loaded `defer`.
   Add-to-cart submit itself is handled globally in theme.js (data-product-form).
   ========================================================================== */
(function () {
  "use strict";
  const root = document.querySelector("[data-product]");
  if (!root) return;

  const $ = (s, c = root) => c.querySelector(s);
  const $$ = (s, c = root) => Array.from(c.querySelectorAll(s));

  let variants = [];
  try {
    variants = JSON.parse($("[data-variants]").textContent);
  } catch (e) {
    variants = [];
  }

  const form = $("[data-product-form]");
  const idInput = form ? form.querySelector('[name="id"]') : null;
  const priceEl = $("[data-price]");
  const compareEl = $("[data-compare-price]");
  const submitBtn = form ? form.querySelector('[type="submit"]') : null;
  const submitLabel = submitBtn ? submitBtn.querySelector("[data-submit-label]") : null;
  const optionInputs = $$("[data-option-input]");

  const money = (cents) =>
    window.Skemino && window.Skemino.formatMoney
      ? window.Skemino.formatMoney(cents)
      : (cents / 100).toLocaleString(undefined, { style: "currency", currency: "EUR" });

  function selectedOptions() {
    const byPosition = {};
    optionInputs.forEach((input) => {
      if (input.type === "radio" && !input.checked) return;
      byPosition[input.dataset.optionPosition] = input.value;
    });
    return byPosition;
  }

  function matchVariant() {
    // Single-SKU / default-variant product: no option inputs → first variant.
    if (optionInputs.length === 0) return variants[0];
    const opts = selectedOptions();
    return variants.find((v) =>
      ["option1", "option2", "option3"].every((key, i) => {
        const pos = String(i + 1);
        if (!(pos in opts)) return v[key] === null || v[key] === undefined;
        return v[key] === opts[pos];
      })
    );
  }

  function setMediaFor(variant) {
    if (!variant || !variant.featured_media) return;
    const mediaId = variant.featured_media.id || variant.featured_media;
    const target = root.querySelector('[data-media-id="' + mediaId + '"]');
    if (target && typeof target.click === "function") target.click();
  }

  function update() {
    const variant = matchVariant();
    if (!variant) {
      if (submitBtn) {
        submitBtn.setAttribute("aria-disabled", "true");
        if (submitLabel) submitLabel.textContent = window.Skemino.strings.unavailable || "Non disponibile";
      }
      return;
    }
    if (idInput) idInput.value = variant.id;

    if (priceEl) priceEl.textContent = money(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = money(variant.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
    if (submitBtn) {
      if (variant.available) {
        submitBtn.removeAttribute("aria-disabled");
        if (submitLabel) submitLabel.textContent = window.Skemino.strings.addToCart || "Aggiungi al carrello";
      } else {
        submitBtn.setAttribute("aria-disabled", "true");
        if (submitLabel) submitLabel.textContent = window.Skemino.strings.soldOut || "Esaurito";
      }
    }
    setMediaFor(variant);
    history.replaceState({}, "", "?variant=" + variant.id);
  }

  optionInputs.forEach((input) => input.addEventListener("change", update));

  /* Gallery thumb → main image swap (cross-fade + responsive srcset preserved) */
  const galleryMain = $("[data-gallery-main]");
  const thumbs = $$("[data-thumb]");
  if (galleryMain && thumbs.length) {
    const mainImg = galleryMain.querySelector("img");

    function swapMain(url) {
      if (!mainImg || !url) return;
      galleryMain.classList.add("is-swapping");
      try {
        if (/_\d+x\d*\.[a-z]+/i.test(url)) {
          // Rebuild a responsive srcset from Shopify's _<width>x token.
          mainImg.srcset = [600, 900, 1200, 1600]
            .map((w) => url.replace(/_\d+x\d*(\.[a-z]+)/i, "_" + w + "x$1") + " " + w + "w")
            .join(", ");
          mainImg.sizes = "(min-width: 900px) 48vw, 100vw";
        } else {
          mainImg.removeAttribute("srcset");
        }
      } catch (e) {
        mainImg.removeAttribute("srcset");
      }
      mainImg.src = url;
      mainImg.addEventListener("load", () => galleryMain.classList.remove("is-swapping"), { once: true });
      setTimeout(() => galleryMain.classList.remove("is-swapping"), 420);
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        swapMain(thumb.dataset.thumb);
        thumbs.forEach((t) => t.removeAttribute("aria-current"));
        thumb.setAttribute("aria-current", "true");
      });
    });
  }

  /* Quantity stepper on the product form */
  const qty = $("[data-qty]");
  if (qty) {
    const input = $("[data-qty-input]", qty);
    const clamp = (n) => Math.max(1, n || 1);
    $("[data-qty-up]", qty).addEventListener("click", () => {
      input.value = clamp(parseInt(input.value, 10) + 1);
    });
    $("[data-qty-down]", qty).addEventListener("click", () => {
      input.value = clamp(parseInt(input.value, 10) - 1);
    });
  }

  /* Sticky add-to-cart bar — show after hero ATC scrolls out */
  const stickyBar = document.querySelector("[data-sticky-atc]");
  const anchor = $("[data-atc-anchor]");
  if (stickyBar && anchor && "IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      ([entry]) => stickyBar.classList.toggle("is-visible", !entry.isIntersecting),
      { rootMargin: "0px 0px -100% 0px" }
    );
    io.observe(anchor);
    /* Clean up observer on navigation / bfcache to avoid leaks. */
    window.addEventListener("pagehide", () => io.disconnect(), { once: true });
    const stickyBtn = stickyBar.querySelector("[data-sticky-add]");
    if (stickyBtn && submitBtn) stickyBtn.addEventListener("click", () => submitBtn.click());
  }

  update();
})();
